export default __webpack_public_path__ + "static/la-logo-1bd93cbda42179c127e4e07c44138254.svg";